// extracted by mini-css-extract-plugin
module.exports = {"failure":"CreateRecipientOnEnter_failure__Pra7o","error":"CreateRecipientOnEnter_error__ewwZo"};